module.exports = __webpack_public_path__ + "9466addbe8d1b36caed2ae54176590a4.MP3";